module.exports = __webpack_public_path__ + "static/media/001 Cover I GUERRA M.7069e022.svg";